import React from 'react'
import {
    useIframeYoutubeVideoFetching,
    VideoDataFrame
} from '@config/hooks/seoVideoConfig'
import NextHead from 'next/head'
import { useStoreConfig } from 'config/hooks/useStoreConfig'

type YoutubeVideoProps = {
    pathname: string
}

export type ItemListData = {
    '@context': string
    '@type': string
    itemListElement: itemListElement
}
export type itemListElement = {
    '@type': string
    position: number
    name: string
    url: string
    thumbnailUrl: string[]
    duration: string
    contentUrl: string
    embedUrl: string
}[]
export const YoutubeVideoSchema = (
    pathname: YoutubeVideoProps
): JSX.Element | null => {
    const config = useStoreConfig()
    let data = {}
    const { baseUrl } = config.base.url
    const iframeFetchedData = useIframeYoutubeVideoFetching()
    const isVideoAvailable = iframeFetchedData.length

    if (isVideoAvailable) {
        const id = iframeFetchedData[0]?.id
        if (isVideoAvailable > 1) {
            const itemListElement = iframeFetchedData?.map(
                (item: VideoDataFrame, i) => ({
                    '@type': item.id,
                    position: i + 1,
                    name: item.title,
                    url: `${baseUrl}${pathname.pathname}`,
                    description: item.description,
                    thumbnailUrl: [item.contentUrl],
                    duration: item.duration,
                    uploadDate: item.uploadDate,
                    contentUrl: item.url,
                    embedUrl: item.src
                })
            )
            data = {
                '@context': 'https://schema.org',
                '@type': 'ItemList',
                '@id': `${baseUrl}#${id}`,
                itemListElement
            }
        } else {
            data = {
                '@context': 'https://schema.org',
                '@type': id,
                '@id': `${baseUrl}#${id}`,
                name: iframeFetchedData[0]?.title,
                url: `${baseUrl}${pathname.pathname}`,
                thumbnailUrl: [iframeFetchedData[0]?.contentUrl],
                description: iframeFetchedData[0]?.description,
                duration: iframeFetchedData[0]?.duration,
                contentUrl: iframeFetchedData[0]?.url,
                embedUrl: iframeFetchedData[0]?.src,
                uploadDate: iframeFetchedData[0]?.uploadDate
            }
        }
    }

    return (
        <NextHead>
            <script
                type="text/javascript"
                src="https://www.youtube.com/iframe_api"
            />
            {isVideoAvailable ? (
                <script
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{
                        __html: JSON.stringify(data, null, '\t')
                    }}
                />
            ) : null}
        </NextHead>
    )
}
